export default "__VITE_ASSET__886afe9b__"